// opervex-frontend/src/contexts/LoadingContext.js
import React, { createContext, useCallback, useContext, useState } from "react";
import { Spinner } from "react-bootstrap";

const LoadingContext = createContext(null);

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const setLoadingScreen = useCallback((value) => {
    setIsLoading(value);
  }, []);

  return (
    <LoadingContext.Provider value={{ setLoadingScreen, isLoading }}>
      {children}

      {isLoading && (
        <div style={styles.overlay}>
          <div style={styles.content}>
            <Spinner animation="border" role="status" />
            <span style={styles.text}>Carregando...</span>
          </div>
        </div>
      )}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);

  if (!context) {
    throw new Error("useLoading deve ser usado dentro de LoadingProvider");
  }

  return context;
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.35)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 99999,
  },

  content: {
    backgroundColor: "#fff",
    padding: "20px 30px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
  },

  text: {
    fontSize: "16px",
    fontWeight: "500",
  },
};
